/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { EditOutlined } from '@ant-design/icons'
import * as React from 'react'

import { MemberProps } from '../convention'

type Props = {
  onClick: () => void
}

const Title: React.FC<MemberProps<IProject, Props>> = ({ member, props: { onClick } }) => (
  <span>
    <span>{member?.name}</span>
    <If condition={member}>
      <span onClick={onClick} className="text-lg ml-2 pointer">
        <EditOutlined />
      </span>
    </If>
  </span>
)

export default Title
